import styled from "src/lib/styles/css";

//#region [Styles]
const SContentWrapper = styled.div`
	width: 100%;
	max-width: 1640px;

	@media (min-width: 550px) {
		margin: 0 auto;
		padding: 0 15px;
        background-color: var(--backgroundcolor);
	}

`;
//#endregion


//#region [Component]
export default SContentWrapper;
//#endregion